import { render, staticRenderFns } from "./AppStatusChangeConfirmationDialog.vue?vue&type=template&id=28505a66&scoped=true&"
import script from "./AppStatusChangeConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./AppStatusChangeConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28505a66",
  null
  
)

export default component.exports